import React from 'react';
import { StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const CARD_COUNT = 6;

export const OrganizationsScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {Array.from({ length: CARD_COUNT }).map((_, i) => (
      <SkeletonCard key={i} style={styles.cardSpacing}>
        <SkeletonBone width="70%" height={18} />
        <SkeletonBone width="50%" height={14} />
      </SkeletonCard>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 12,
  },
  cardSpacing: {
    marginBottom: 12,
  },
});
